import { createSlice } from '@reduxjs/toolkit';
import { ICreditCard } from '../../interfaces';
import { IFormControl } from '../../../../../ui/forms/interfaces';
import { createControl } from '../../../../../domain/validation/validation';
import { default as cloneDeep } from 'lodash/cloneDeep';

interface ISavedCreditCardsState{

    // zooz credit card token of the saved card
    savedCreditCardToken: string;
    networkTransactionID: string;
    isRecurringNetworkTransactionID: boolean;
    savedCreditCards: ICreditCard[];
    inUsePopupShown: boolean;

    cvvControl: IFormControl,
}

/**
 * initial state
 */
const initialState: ISavedCreditCardsState = {
    savedCreditCardToken: '',
    networkTransactionID: '',
    isRecurringNetworkTransactionID: false,
    savedCreditCards: [],
    inUsePopupShown: false,

    cvvControl: createControl('cvvControl', '', {
        required: true,
        int: true,
        maxlength: 4,
    }),
};

const savedCreditCardSlice = createSlice({
    name: 'saved-credit-card',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },

        setControl(state, action) {
            return {
                ...state,
                [action.payload.controlName]: cloneDeep(action.payload.control),
            }
        },
    }
});

export default savedCreditCardSlice;